export enum NodeType {
    Source = 0,
    Destination = 1
}